<template>
    <div>
         <!-- <headEnterprise></headEnterprise> -->
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                   <sidebar></sidebar> 
                </el-aside>
                <el-main>
                    <contTitle  :obj="obj" :contTitle="contTitle"></contTitle>
                    <companySide class="mt-30" :isButton="isButton"   @release="gorelease()"></companySide>
                    <div class="mt-30">
                        <paletteBar :paletteObj="paletteObj"  @onPaletteBar="addInformation()" @onDelPalet="deleteInfo()"  @onEditPalet="editInfo()" ></paletteBar>
                        <div class="mt-10">
                            <div class="corporate_top fdc">
                                <img src="../../assets/images/photo.png">
                                <div>
                                    <p>浙江某公司电镀废水处理工程【项目走访】</p>
                                    <p>将近8月底，我们接到了来自浙江的一家公司邀请，希望跟我们谈一谈关于电镀废水处理的问题。随着我国工业化水平的不断提高,我国国内的化工厂 ...</p>
                                    <p>
                                        <span>详情 ></span>
                                    </p>
                                </div>
                            </div>



                            <div class="corporate_middle fdw">
                                <div class= "middle_cont" v-for="(item,index) in list" :key="index">
                                    <div class="middle_cont_left">
                                         <img :src="item.cover" alt="">
                                    </div>
                                    <p class="mt-10 title_far">{{item.title}}</p>
                                    <div class="middle_text fdc"> 
                                       <p>{{ item.createTime.substring(0,10)}}</p>
                                        <p>
                                            <span>浏览数 : </span><span>{{item.readCount}}</span>
                                        </p>
                                    </div>
                                    <div class="fcc place " @click="onDetail(item)">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="item.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                  
                                </div>
                            </div>           
                        </div>
                        <!--分页-->
                        <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>

                        <div style="margin-top:20%">
                          <notList :notCode="notCode"></notList>
                       </div>
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {delIndustryinfo,industryinfoList} from "@/api/company"
import headEnterprise from "../../common/headEnterprise"
import sidebar from '../../common/sidebar'
import companySide from '../../common/companySide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import paletteBar from '../../common/paletteBar'
import contTitle from '../../common/contTitle'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
  components:{
    headEnterprise,  sidebar,companySide,commBanner,titleHead,paletteBar,contTitle,Pagination,notList
  }, 
  data(){
      return{
        headTitle:'企业资讯',
        contTitle:'企业基本信息',
        obj:{
           title:'企业资讯',   
           isShow:false,
           isColor:false,
           roleType:3,
           personalType:9,
        },
         paletteObj:{
            paletteTitle:'企业资讯',
            paletteCount:3,
            paletteName:'添加资讯',
            paletteText:'删除资讯',
            paletteView:'编辑资讯',
            isShow:false,
            isDelete:true,
            isEdit:true
        },
         list:[],
         listQuery:{
          userid: this.$store.state.user.userInfo.data.userId,
          curPage:1,
          limit:6
         },
         total:0,//总条数
         readId:'',
         checkList:[],
         notCode:false,
         isButton:false,
         id:''
      }
  },
  created(){
      this.getList();
  },
  methods:{
      //添加资讯
       addInformation(){
         this.$router.push('/corporate_owned')
      },
      //编辑
      editInfo(){
         if(this.checkList.length ==0){
            this.$message({
                message:'至少选择一条数据',
                type:"warning",
                duration:1000,
            });
          }else{
             this.$router.push({
                path:'/corporate_owned',
                query:{id:this.id}
             })   
          }
      },
      //删除资讯
      deleteInfo(){
        if(this.checkList.length ==0){
          this.$message({
            message:'至少选择一条数据',
            type:"warning",
            duration:1000,
          })
        }else{
          let parmas ={id:this.readId};
          delIndustryinfo(parmas).then(res=>{
             if(res.code ==0){
                this.$message({
                    message:'删除成功！',
                    type: 'success',
                    duration:1000,
                    onClose:()=>{
                      this.getList();
                    }
                 });
             }
         }).catch(err=>{});
        }
          
      },
      //获取列表
      getList(){
          industryinfoList({
            ...this.listQuery,
            releaseType:2,
            userid:this.$store.state.user.userInfo.data.userId
          }).then(res=>{
              if(res.code ==0){
                this.list = res.page.list;
                this.total = res.page.totalCount;
                this.list.length == 0 ? this.notCode = true : this.notCode = false;
              }         
          }).catch(err=>{})
      },
      //选中
      onChange(){
        this.checkList.forEach(item =>{
             this.readId = item;
        });
      },
       //分页
      pageChange(item){
        this.listQuery['curPage'] = item.page;
        this.listQuery['limit'] = item.limit;
        this.getList();
      },
      //发布需求
      gorelease(){
          this.$router.push('/demand')
      },
      onDetail(data){
        this.id = data.id;
      }
  }
}
</script>
<style scoped>
/* .el-aside{
    height: 930px;
} */
.title_far{
   overflow: hidden;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 2;
   height: 42px;
}
.mt-30{
    margin-top: 30px;
}
.mt-15{
    margin-top: 15px;
}
.corporate_top{
    display: none;
}
.corporate_top img{
    width: 60%;
    height: 336px;
}
.corporate_top div{
    width: 40%;
    height: 336px;
    background: #02B854;
    padding: 40px 30px;
    text-align: left;
}
.corporate_top div p:first-child{ 
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FEFEFE;
    margin-top: 25px;
}
.corporate_top div p:nth-child(2){    
    margin-top: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FEFEFE;
    line-height: 24px;
}
.corporate_top div p:last-child{   
    margin-top: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FEFEFE;
}
.corporate_middle{
    margin-top: 15px;
}
.middle_cont{
    width: 30%;
    text-align: left;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    margin-right: 20px;
}
.middle_cont_left{
    overflow: hidden;
}
.middle_cont_left img{
    width: 100%;
    height: 162px;
    transition: all 0.6s;
}
.middle_cont_left img:hover{
    transform: scale(1.4);
}
.middle_cont p:nth-child(1){   
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.middle_text{
    margin-top: 10px;
}
.middle_text p:nth-child(1){
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;  
}
.middle_text p:nth-child(2){   
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
}

.el-pagination{
   margin-top: 40px;
}
.corporate_middle>>>.el-checkbox__label{
  display: none;
}
.corporate_middle>>>.el-radio__input.is-checked .el-radio__inner{
   background:#50B035;
   border-color: #50B035;
}
.place{
   margin-top: 10px;
}

.place>>>.el-radio__input.is-checked .el-radio__inner{
   background:#50B035;
   border-color: #50B035;
}
.place>>> .el-checkbox__inner {
  border-radius: 50%;
  width: 18px;
  height: 18px;
  border: 1px solid #50b035;
}
.place >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #50b035;
}

.place >>>.el-checkbox__inner::after{
    height: 10px;
    left: 6px;
    position: absolute;
    top: 1px;
} 
.place >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #50b035;
  border-color: #50b035;
  border-radius: 50%;
}
.place >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #50b035;
}

</style>


// WEBPACK FOOTER //
// src/view/company/corporate_list.vue